<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout row> </v-layout>

    <v-container
      fluid
      v-if="
        $store.state.tradeData.report_selection ===
          $store.state.tradeData.report_selections[0]['value']
      "
    >
      <v-layout class="justify-space-around align-center" row>
        <!-- Chart 01 = Competitors into target market for specific product -->
        <v-flex class="pa-2 xs12 sm12 md4 lg6 xl6 align-center">
          <Hist_impexpgraph class="d-flex justify-center"></Hist_impexpgraph>
        </v-flex>
        <!-- Chart 02 = Trade values between home market and target market for specific product -->
        <v-flex id="1p1c-hist_impexpgraph_tm" class="pa-1 xs12 sm12 md6 lg6 xl6">
             <Hist_impexpgraph_tm_total
            class="d-flex justify-center"
          ></Hist_impexpgraph_tm_total>
        </v-flex>
        <!-- Chart 03 = Relative potential into target market for specific product -->
        <v-flex id="1p1c-hist_impexpgraph_tm_total" class="pa-2 xs12 sm12 md6 lg6 xl6">
       <Hist_impexpgraph_tm class="d-flex justify-center"></Hist_impexpgraph_tm>
        </v-flex>
        <!-- Chart 5 Home market total imports & exports + exports to target market of specific product -->
        <v-flex id="1p1c-hist_impexpgraph" class="pa-2 xs12 sm12 md6 lg6 xl6">
          <Top6graph class="d-flex justify-center align-center"></Top6graph>
        </v-flex>
      </v-layout>
    </v-container>
    ]
  </div>
</template>

<script>
import Hist_impexpgraph from '@/components/trade-dsm-application/graphs/1p1c/hist-impexp-graph-1p1c';
import Hist_impexpgraph_tm from '@/components/trade-dsm-application/graphs/1p1c/hist-impexp-graph-tm-1p1c';
import Hist_impexpgraph_tm_total from '@/components/trade-dsm-application/graphs/1pmc/hist-impexp-graph-tm-total-1p1c';
import Top6graph from '@/components/trade-dsm-application/graphs/1p1c/top6-graph-1p1c';

export default {
  name: 'DSMSingleGraphs',
  components: {
    Hist_impexpgraph,
    Hist_impexpgraph_tm,
    Hist_impexpgraph_tm_total,
    Top6graph,
  },
};
</script>

<style scoped>
.html2canvas-container {
  width: 3000px !important;
  height: 3000px !important;
}
</style>
